import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Preview.css";
import card1 from "../../images/preview-card1.png";

function Preview() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
	
  return (
    <section className="preview">
      <div className="preview__container">
        <div className="preview__card card1">
          <div className="preview__text-container">
            <h1 className="preview__card-title">PROPERTY DEVELOPMENT</h1>
            <h2 className="preview__card-subtitle">
              We offer comprehensive solutions for the implementation of your
              construction projects in the USA. Whether you are building your
              dream home from scratch or renovating an existing property, we
              provide a full range of development and construction services
            </h2>
            <Link to="/property-development" className="preview__button">
              Read More
            </Link>
          </div>
        </div>
        <div className="preview__card card2">
          <div className="preview__text-container">
            <h1 className="preview__card-title">CONSTRUCTION MATERIALS</h1>
            <h2 className="preview__card-subtitle">
              We offer a wide selection of quality materials to complete your
              construction or renovation project. Our range includes everything
              necessary to create a stylish, functional, and durable interior
            </h2>
            <Link to="/construction-materials" className="preview__button">
              Read More
            </Link>
          </div>
        </div>
        <div className="preview__card card3">
          <div className="preview__text-container">
            <h1 className="preview__card-title">INVESTMENT OPPORTUNITIES</h1>
            <h2 className="preview__card-subtitle">
              We offer unique investment opportunities in the real estate and
              construction sector. Our years of experience and deep market
              knowledge allow us to create high-yield projects while minimizing
              risks for our investors
            </h2>
            <Link to="/investment-opportnites" className="preview__button">
              Read More
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Preview;
